// project-imports
// import applications from './applications';
// import widget from './widget';
// import formsTables from './forms-tables';
// import chartsMap from './charts-map';
// import support from './support';
// import pages from './pages';
import users, { usersSectionDefault } from './users';
//TODO: ADD ROUTES
// import strategies from './strategy-generator';
// import historicalPrices from './historical-prices';
import simulations from './simulation';
import app from './app';
import analyzer from './analyzer';

// types
import { NavItemType } from 'types/menu';
import configs from './configs';
import backtestingSimulations from './simulation-backtesting';
import recommendations from './recommendations';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
  items: [users, app, analyzer, simulations, recommendations, backtestingSimulations, configs]
};

export const menuItemsDefault: { items: NavItemType[] } = {
  items: [usersSectionDefault, backtestingSimulations, simulations]
};

export default menuItems;
